import { render } from "./characterCard.vue?vue&type=template&id=b71d0530&bindings={\"characterUrl\":\"props\",\"character\":\"data\",\"isLoading\":\"data\"}"
import script from "./characterCard.vue?vue&type=script&lang=js"
export * from "./characterCard.vue?vue&type=script&lang=js"
script.render = render

export default script